import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {GroundGroupsService} from '../../../core/services/ground-groups.service';
import {ActionService, TenantState} from '../../../core/services/action.service';
import {TenantService} from '../../../core/services/tenant.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { translateGroundPositionType } from 'src/app/helpers/format-ground-position-type';

@Component({
  selector: 'app-setup-levels',
  templateUrl: './setup-levels.component.html',
  styleUrls: ['./setup-levels.component.scss']
})
export class SetupLevelsComponent implements OnInit {

  levels = [];
  groups = [];
  constructor(
    private tenantsService: TenantService,
    private groundGroupsService: GroundGroupsService,
    private actionService: ActionService,
    private router: Router,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.loadInfo();
  }

  loadInfo(){
    this.loadTenantLevels();
    this.loadGroundGroups();
  }

  async loadTenantLevels(){
    const levels = await this.tenantsService.getLevels();
    this.levels = levels;
  }
  async loadGroundGroups(){
    let groups = await this.groundGroupsService.getGroundGroups(true);
    groups = groups.map( g => {
      const group = {...g, title: this.translateType(g.type)+" - "+g.name}
      return group;
    });
    this.groups = groups.sort((a, b) =>{ return (a.type+a.name).localeCompare(b.type+b.name)});
  }

  async toSetup(){
    await this.router.navigate(['/setup']);
  }

  translateType(type) {
    return translateGroundPositionType(type);
  }

  async toLevels(p: any){
    await this.router.navigate(['ground-group-levels', p.id]);
  }

  onRemoveLevelFromTenant($event){
    const {levelId} = $event;
    this.actionService.removeLevelFromTenant({id:levelId}).then(() => {
      this.loadInfo();
    });
  }
  onCreateLevelForTenant($event){
    const {values} = $event;
    this.actionService.addLevelToTenant(values).then(()=>{
      this.loadInfo();
    });
  }
  onCreateLevelForGroup($event){
    const {values, id} = $event;
    const res = {...values, groundPositionGroupId: id}
    this.actionService.addLevelToGroundGroup(res).then(() => {
      this.loadInfo();
    });
  }
  onRemoveLevelFromGroup($event){
    const {id, levelId} = $event;
    this.actionService.removeLevelToGroundGroup({id: levelId}).then(() => {
      this.loadInfo();
    });
  }

  onRemoveGroupLevels($event){
    const {id} = $event;
    this.actionService.removeAllGroupLevels({id}).then(() => {
      this.loadInfo();
    }).catch(err => {
      if (err.error.body.type === "GROUND_POSITION_GROUP_LEVEL_ERROR_NOT_FOUND") {
        const message = "Não existem níveis cadastrados neste setor.";
        this.errorService.openErrorSnackBarWithCustomMessage(message);
      }
    });
  }

  async finish(){
    await this.actionService.setTenantState({state: TenantState.SETUP_REVIEW});
    await this.router.navigate(['/setup-finish']);
  }
}
